// Orchestrator: hent config + session -> vis login eller editor.
import './style.css';
import { getConfig, getSession } from './api.js';
import { renderLogin } from './login.js';
import { mountEditor } from './editor.js';

const root = document.getElementById('app');

async function boot() {
  const [config, session] = await Promise.all([getConfig(), getSession()]);
  if (session.authenticated) {
    // Uden et dokument-id fra serveren må editoren ikke montere: en gæt-fallback
    // ville forbinde til et forkert rum (split-brain). Fejl højlydt i stedet.
    if (!config.doc) {
      root.innerHTML = '<div class="fatal">Kunne ikke hente dokument-opsætningen fra serveren. Genindlæs siden for at prøve igen.</div>';
      return;
    }
    mountEditor(root, config, session);
  } else {
    renderLogin(root, config);
  }
}

boot().catch((e) => {
  root.innerHTML = '<div class="fatal">Kunne ikke starte værktøjet. Genindlæs siden.</div>';
  console.error(e);
});
